import {type CurrentUserEntityPermissionsJsContract} from "../../Scalesoft.HealthPlatform.TelemedicineV2.Core/Scripts/AjaxWebHubClients.generated";

declare const globalPermissionsList: string[];
declare const entityPermissionsList: CurrentUserEntityPermissionsJsContract[];
export default class PermissionChecker {
    public static init(): void {
        const scriptElement = document.getElementById("permissionsScripts");
        scriptElement?.remove();
    }

    public static userHasPermission(permissionName: string): boolean {
        if (!globalPermissionsList) {
            throw Error(`Missing current user role permissions list`);
        }
        return globalPermissionsList.includes(permissionName);
    }

    public static userHasEntityPermission(entityId: number, entityType: any, permissionName: string): boolean {
        if (!entityPermissionsList) {
            throw Error(`Missing entity permission data, entityId=${entityId}, entityType=${entityType}`);
        }
        const matchingEntityPermissionsObject = entityPermissionsList
            .filter((x) => x.authorizedEntity?.entityId === entityId &&
                x.authorizedEntity?.entityType === entityType);
        if (matchingEntityPermissionsObject.length === 0) {
            throw Error(`Missing entity permission data, entityId=${entityId}, entityType=${entityType}`);
        }
        return matchingEntityPermissionsObject[0].permissions?.includes(permissionName) ?? false;
    }
}
